import { render, staticRenderFns } from "./AgreementHome.vue?vue&type=template&id=513b534f&"
import script from "./AgreementHome.vue?vue&type=script&lang=ts&"
export * from "./AgreementHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports